import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const textAreaRecipe = sva({
    slots: ['root', 'shared', 'growContainer', 'textArea', 'label', 'description', 'error'],
    base: {
        // Shared is applied to both the 'grow container'
        // and the textarea, to have their sizing match up
        // properties that would affect that need to go into both
        shared: {
            textStyle: 'inherit',
            boxSizing: 'border-box',
            scrollbarGutter: 'stable',
            overflowWrap: 'anywhere',
            layerStyle: 'controlTransparent', // this has padding/border/color/bgcolor
        },
        growContainer: {
            display: 'grid',
            // this ::after pseudo-element will contain an example string that is used to calculate height.
            // its important that it has the same font-size, border, padding, etc as the textArea so that height is calculated correctly.
            _after: {
                content: 'attr(data-replicated-value) " "',
                whiteSpace: 'pre-wrap',
                visibility: 'hidden',
                gridArea: '1/1/2/2',
                overflowY: 'scroll',
            },
        },
        textArea: {
            gridArea: '1/1/2/2',
            appearance: 'none',
            resize: 'none', // prevents resizing via corner clicking element
            outline: '0',
            height: '[unset]',
            maxWidth: '[100%]', // ??

            // Scroll bars:
            // hide scrollbar until hover or focus
            scrollbarColor: '[transparent transparent]',
            _hoverOrFocus: {
                scrollbarColor: '[{colors.text.placeholder} transparent]',
            },
            _placeholder: {
                color: 'text.placeholder',
            },
            _invalid: {
                _placeholder: {
                    color: 'text.error',
                },
            },
            _disabled: {
                cursor: 'not-allowed',
            },
        },
        label: {},
        description: {},
        error: {},
    },
    variants: {
        variant: {
            // these variants get passed through to the input container
            // which actually gives the visual styles
            contained: {},
            outlined: {},
        },
        size: {
            // these variants get passed through to the input container
            // which actually gives the visual styles
            small: {},
            medium: {},
            large: {},
        },
        shape: {
            // these variants get passed through to the input container
            // which actually gives the visual styles
            box: {},
            rounded: {},
        },
        fullWidth: {
            false: {},
            true: {
                root: {
                    width: '[100%]',
                },
                shared: {
                    width: '[100%]',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'outlined',
        shape: 'box',
        size: 'medium',
        fullWidth: false,
    },
});

type TextAreaRecipeProps = RecipeVariantProps<typeof textAreaRecipe>;

export { textAreaRecipe, textAreaRecipe as default };
export type { TextAreaRecipeProps };
